import AppAuthenticationTemplate from './AppAuthenticationTemplate';

export default AppAuthenticationTemplate;
